import React from "react";
import bardstownfloor from "assets/bardstownfloor.webp";
import "./WhyAce.css";

const PILLARS = [
  {
    title: "Safe & supportive",
    text: "A welcoming gym where every athlete feels like family.",
    accent: "coral",
  },
  {
    title: "Build confidence",
    text: "Strength, coordination, and self-esteem through structured training.",
    accent: "gold",
  },
  {
    title: "Grow as a team",
    text: "Discipline, perseverance, and teamwork on and off the floor.",
    accent: "sky",
  },
  {
    title: "Programs for every age",
    text: "Recreational, competitive, and private lessons.",
    accent: "berry",
  },
];

const WhyAce = () => (
  <section className="home-section" aria-labelledby="why-ace-heading">
    <div className="home-section__inner home-why">
      <div className="home-why__content">
        <header className="home-section__header">
          <h2 id="why-ace-heading" className="home-section__title">
            Why Ace Gymnastics
          </h2>
          <p className="home-section__subtitle">
            We are a family-owned facility in the heart of Bardstown, dedicated
            to helping students reach their full potential in gymnastics and
            beyond.
          </p>
        </header>
        <ul className="home-why__pillars">
          {PILLARS.map((pillar) => (
            <li
              key={pillar.title}
              className={`home-why__pillar home-why__pillar--${pillar.accent}`}
            >
              <h3>{pillar.title}</h3>
              <p>{pillar.text}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="home-why__image-wrap">
        <img
          src={bardstownfloor}
          alt="Ace Gymnastics training floor in Bardstown"
          width="600"
          height="600"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);

export default WhyAce;
